import { gsap } from "gsap/all";
// gsap.registerPlugin(scrollTrigger);

export default () => {
  // const heroTrigger = document.getElementById("hero-wrapper-animation");
  const heroImg = document.getElementById("hero-img-animation");
  const heroLogo = document.getElementById("hero-logo-animation");

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: heroImg,
      toggleActions: "play none none reverse",
      start: "top 15%",
      endTrigger: heroImg,
      end: "bottom top",
      markers: false,
    },
    defaults: {
      ease: "power2.in",
    },
  });

  tl.to(heroLogo, {
    duration: 0.5,
    y: "-500%",
  }).to(heroImg, { duration: 0.5, x: "-90%" }, "-=0.5");
};
